import { defineMessages } from "react-intl";

const baseId = "t.pages.UserReferenceStepOne.";

export default defineMessages({
  PanelTitle: {
    id: baseId + "PanelTitle",
    defaultMessage: "Search Users",
  },
  noUserFound: {
    id: baseId + "noUserFound",
    defaultMessage: "No users found",
  },
  //FILTER
  allFilterLabelForm: {
    id: baseId + "allFilterLabelForm",
    defaultMessage: "ID,Name,Surname",
  },

  CTA_BACK: {
    id: baseId + "CTA_BACK",
    defaultMessage: "Back to Home",
  },
});
